(() => {
  if (customElements.get('featured-collection')) {
    return;
  }

  class FeaturedCollection extends HTMLElement {
    constructor() {
      super();

      this.slider = null;
      this.swiper = null;

    }

    connectedCallback() {
      const swiperContainer = this.querySelector('[data-swiper]');
      const flip = this.querySelector('[data-flip]');
      console.log(flip);

      if (!swiperContainer) {
        return;
      }

      // Vérifier si c'est le bnz-collection-slider pour appliquer un gap de 20px
      const isBnzCollectionSlider = this.classList.contains('bnz-collection-slider');
      
      const swiperOptions = {
        slidesPerView: 2.05,
        spaceBetween: isBnzCollectionSlider ? 20 : 12,
        reverseDirection: flip ? true : false,
        navigation: {
          nextEl: '.featured-collection__arrow-next',
          prevEl: '.featured-collection__arrow-prev'
        },
        breakpoints: {
          990: {
            spaceBetween: isBnzCollectionSlider ? 20 : 32,
            slidesPerView: 2,
          },
        }
      };

      this.swiper = new Swiper(swiperContainer, swiperOptions);
    }
  }

  customElements.define('featured-collection', FeaturedCollection);
})();
